import { useState } from 'react';

const API_URL = process.env.REACT_APP_API_URL;
const MESES   = ['Enero','Febrero','Marzo','Abril','Mayo','Junio',
                 'Julio','Agosto','Septiembre','Octubre','Noviembre','Diciembre'];
const colorEstado = {
  Aprobada: '#28a745', Pendiente: '#007bff',
  Rechazada: '#dc3545', Cancelada: '#6c757d'
};

const formatFecha = (f) => {
  if (!f) return '—';
  const [y, m, d] = f.toString().split('T')[0].split('-').map(Number);
  return new Date(y, m - 1, d).toLocaleDateString('es-MX', {
    day: 'numeric', month: 'long', year: 'numeric'
  });
};

export default function ModalReporteVacaciones({ token, onClose }) {
  const hoy = new Date();
  const [mes, setMes]         = useState(hoy.getMonth() + 1);
  const [año, setAño]         = useState(hoy.getFullYear());
  const [reporte, setReporte] = useState([]);
  const [loading, setLoading] = useState(false);
  const [buscado, setBuscado] = useState(false);

  const cargar = async () => {
    setLoading(true);
    try {
      const res  = await fetch(`${API_URL}/vacaciones/reporte?mes=${mes}&año=${año}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      const data = await res.json().catch(() => []);
      setReporte(Array.isArray(data) ? data : []);
      setBuscado(true);
    } finally {
      setLoading(false);
    }
  };

  const exportarPDF = async () => {
    const res = await fetch(`${API_URL}/vacaciones/reporte-pdf?mes=${mes}&año=${año}`, {
      headers: { Authorization: `Bearer ${token}` }
    });
    if (!res.ok) return;
    const blob = await res.blob();
    const url  = URL.createObjectURL(blob);
    const a    = document.createElement('a');
    a.href = url; a.download = `reporte_vacaciones_${MESES[mes-1]}_${año}.pdf`; a.click();
    URL.revokeObjectURL(url);
  };

  const aprobadas  = reporte.filter(s => s.estado === 'Aprobada').length;
  const pendientes = reporte.filter(s => s.estado === 'Pendiente').length;
  const totalDias  = reporte.filter(s => s.estado === 'Aprobada')
                            .reduce((sum, s) => sum + Number(s.dias_solicitados), 0);

  return (
    <div className="overlay" onClick={onClose}>
      <div className="modal" onClick={e => e.stopPropagation()} style={{
        width: 720, maxHeight: '90vh', display: 'flex', flexDirection: 'column'
      }}>
        <div style={{ flexShrink: 0, borderBottom: '1px solid #ddd', paddingBottom: 12, marginBottom: 12 }}>
          <h3 style={{ margin: 0 }}>📊 Reporte de Vacaciones</h3>
        </div>

        {/* Filtros */}
        <div style={{ display: 'flex', gap: 8, alignItems: 'center', marginBottom: 12, flexShrink: 0 }}>
          <select className="form-input" style={{ width: 'auto' }}
            value={mes} onChange={e => setMes(Number(e.target.value))}>
            {MESES.map((m, i) => <option key={i+1} value={i+1}>{m}</option>)}
          </select>
          <select className="form-input" style={{ width: 'auto' }}
            value={año} onChange={e => setAño(Number(e.target.value))}>
            {[2024, 2025, 2026, 2027].map(y => <option key={y} value={y}>{y}</option>)}
          </select>
          <button className="btn-primary" style={{ fontSize: 12 }} onClick={cargar}>
            Buscar
          </button>
          {buscado && reporte.length > 0 && (
            <button className="btn-secondary" style={{ fontSize: 12 }} onClick={exportarPDF}>
              Exportar PDF
            </button>
          )}
        </div>

        {/* Resumen */}
        {buscado && (
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 8, marginBottom: 12, flexShrink: 0 }}>
            {[
              { label: 'Total',          valor: reporte.length, color: '#1e3a5f' },
              { label: 'Aprobadas',      valor: aprobadas,      color: '#28a745' },
              { label: 'Pendientes',     valor: pendientes,     color: '#007bff' },
              { label: 'Días aprobados', valor: totalDias,      color: '#6f42c1' },
            ].map(item => (
              <div key={item.label} style={{
                textAlign: 'center', padding: '8px',
                border: `1px solid ${item.color}30`,
                borderRadius: 6, background: `${item.color}08`
              }}>
                <div style={{ fontSize: 20, fontWeight: 700, color: item.color }}>{item.valor}</div>
                <div style={{ fontSize: 11, color: '#888' }}>{item.label}</div>
              </div>
            ))}
          </div>
        )}

        {/* Lista */}
        <div style={{ overflowY: 'auto', flex: 1 }}>
          {loading && <p style={{ color: '#888', fontSize: 13 }}>Cargando...</p>}

          {!loading && buscado && reporte.length === 0 && (
            <p style={{ color: '#888', fontSize: 13, textAlign: 'center', marginTop: 20 }}>
              Sin solicitudes en {MESES[mes-1]} {año}
            </p>
          )}

          {!loading && reporte.map((s, i) => (
            <div key={i} style={{
              border: '1px solid #eee', borderRadius: 6, padding: '10px 14px',
              marginBottom: 8, borderLeft: `3px solid ${colorEstado[s.estado] ?? '#ccc'}`
            }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <div>
                  <span style={{ fontWeight: 600, fontSize: 13 }}>{s.usuario_nombre}</span>
                  <span style={{ fontSize: 11, color: '#888', marginLeft: 8 }}>
                    {s.puesto} · {s.area_nombre}
                  </span>
                </div>
                <span style={{ fontSize: 11, padding: '2px 8px', borderRadius: 20,
                  color: 'white', background: colorEstado[s.estado] ?? '#ccc' }}>
                  {s.estado}
                </span>
              </div>
              <div style={{ fontSize: 12, color: '#555', marginTop: 4 }}>
                📅 {formatFecha(s.fecha_inicio)} — {formatFecha(s.fecha_regreso)}
                &nbsp;·&nbsp; <b>{s.dias_solicitados} días</b>
                {s.tipo_solicitud !== 'normal' && s.tipo_solicitud && (
                  <span style={{ marginLeft: 8, fontSize: 11, color: '#e67e22' }}>
                    ({s.tipo_solicitud === 'anticipo' ? 'Anticipo' : 'Desc. nómina'})
                  </span>
                )}
              </div>
              {s.aprobado_por_nombre && (
                <div style={{ fontSize: 11, color: '#888', marginTop: 2 }}>
                  Aprobó: {s.aprobado_por_nombre}
                  {s.fecha_respuesta && ` · ${formatFecha(s.fecha_respuesta)}`}
                </div>
              )}
              {s.comentario_gerente && (
                <div style={{ fontSize: 11, color: '#666', marginTop: 2, fontStyle: 'italic' }}>
                  "{s.comentario_gerente}"
                </div>
              )}
            </div>
          ))}
        </div>

        <div style={{ borderTop: '1px solid #ddd', paddingTop: 10, marginTop: 10, flexShrink: 0, textAlign: 'right' }}>
          <button className="btn-secondary" onClick={onClose}>Cerrar</button>
        </div>
      </div>
    </div>
  );
}